import ChevronRightIcon from './ChevronRightIcon'

export default ChevronRightIcon
